import { Autocomplete, TextField } from '@mui/material'
import React from 'react'

const RequestType = () => {
    return (
        <>
            <Autocomplete
                size='small'
                options={top100Films}
                renderInput={(params) => <TextField {...params} label="Request Type" />}
            />
        </>
    )
}

export default RequestType


const top100Films = [
    { label: 'The Shawshank Redemption', year: 1994 },
    { label: 'The Godfather', year: 1972 },
]